import { axios } from '@Root/API'

export const get = id => {
	return axios.get(`subject-module/${id}`)
}
